import { CurrencyType, type VoucherForCampaignInput } from "@/lib/gql/__generated__/graphql";

import type { MarketingCampaignFormModelContextType } from "../../../../ui/_shared/context/context";

type Props = {
	viewModel: MarketingCampaignFormModelContextType["viewModel"];
};

export const viewModelToInput = ({ viewModel }: Props): VoucherForCampaignInput => {
	const {
		hotelID,
		voucherID,
		inSale,
		cinStart,
		cinEnd,
		description,
		mailTemplate,
		name,
		resourceAvailablePrice,
		voucherExplanationForHost,
		voucherGiftList,
		voucherPrice,
		mainKeyVisual,
	} = viewModel;

	const input: VoucherForCampaignInput = {
		hotelID,
		voucherID,

		inSale: inSale.value,

		cinStart: cinStart?.value,
		cinEnd: cinEnd?.value,
		description: description?.value,
		mailTemplate: mailTemplate?.value,
		name: name?.value,
		resourceAvailablePrice: {
			currencyType: resourceAvailablePrice?.currencyType.value ?? CurrencyType.Jpy,
			amount: resourceAvailablePrice?.amount.value ?? 0,
		},
		voucherExplanationForHost: voucherExplanationForHost?.value,
		voucherGiftList: voucherGiftList.value
			? voucherGiftList.value.map((gift) => ({
					guestName: gift.guestName.value,
					guestTel: gift.guestTel?.value || "",
					guestEmail: gift.guestEmail?.value || undefined,
				}))
			: [],
		voucherPrice: {
			currencyType: voucherPrice?.currencyType.value ?? CurrencyType.Jpy,
			amount: voucherPrice?.amount.value ?? 0,
		},
		mainKeyVisual: {
			bucket: mainKeyVisual.bucket.value,
			key: mainKeyVisual.key.value,
			region: mainKeyVisual.region.value,
			mimeType: mainKeyVisual.mimeType?.value,
			fileName: mainKeyVisual.fileName?.value,
		},
	} satisfies VoucherForCampaignInput;

	return input;
};
